var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h200v200H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.067 84.824V60.782c0-29.672-24.32-53.726-54.324-53.726S46.39 31.11 46.39 60.796v24.028H26.73v103.232h148V84.824h-19.662zM63.566 60.796c0-20.288 16.677-36.781 37.177-36.781 20.499 0 37.176 16.493 37.176 36.767v24.042H63.566V60.796z",
    fill: "#fff"
  })));
}
export default SvgLock;